/**
 * @desc - 新聞入力欄表示切り替え
 * @link - https://www.web-officer.com/jquery/how-to-switch-between-display-and-non-display-by-the-selected-value-of-the-select-tag-in-jquery.html

/*------------------------------------------------------------
［チェックされたら選択可能にする］
https://www.nishishi.com/javascript-tips/textform-disabled-by-checkbox.html
-------------------------------------------------------------*/
$(function() {
  var cart_np_val = $(".cart-Acc_Np").val();
  if(cart_np_val == "希望しない") {
    $('input[id="cart-addnp-input"]').prop('disabled', true); //選択不可にする
    $('input[id="cart-addnp-input"]').val("");
  }
  $('.cart-Acc_Np').change( function() {
    var cart_np_val = $(".cart-Acc_Np").val();
    if(cart_np_val == "希望しない") {
      $('input[id="cart-addnp-input"]').prop('disabled', true);
      $('input[id="cart-addnp-input"]').val("");
    } else if (cart_np_val == "希望する") {
      $('input[id="cart-addnp-input"]').prop('disabled', false);
    } 
  });
});